import React, { useState } from "react";
import "./section7Data.css";
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';

const Section7Data = ({
  section7ItemHeading,
  section7Data1,
  section7Data2,
  section7Data3,
  bgColor,
  bdColor,
}) => {
  const [open, setOpen] = useState(false);
  return (
    <div>
      <div className="section7Data-items-list">
        <h3 style={{ background: bgColor, height: "30px" }}>
          {section7ItemHeading}
        </h3>
        <p style={{ border: bdColor }} className="mypc">
          {section7Data1}
        </p>
        <p style={{ border: bdColor }} className="mypc">
          {section7Data2}
        </p>
        <p style={{ border: bdColor }} className="mypc">
          {section7Data3}
        </p>
        <div className="mymob" style={{width: '60%'}}>
          <p
            style={{ border: bdColor, position: "relative", textAlign: 'left', width: '100%' }}
            onClick={() => setOpen((prev) => !prev)}            
          >
            <span
              style={{
                background: "#FAD867",
                display: "inline-block",
                position: "absolute",
                right: "10px",
                top: "25%",
                width: "20px",
                height: "20px",
                color: '#000',
                textAlign: 'center'
              }}              
            >
              <ArrowDropDownIcon/>
            </span>
            <p style={{width: '80%', marginLeft: '-20px'}}>
            {section7Data1}
            </p>
          </p>
          <div style={!open ? { display: "none" } : null}>
            <p style={{ border: bdColor }}>{section7Data2}</p>
            <p style={{ border: bdColor }}>{section7Data3}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Section7Data;
